// start:ng42.barrel
import './cca-available-summary.component';
// end:ng42.barrel

